module.exports = __webpack_public_path__ + "img/logo_simple_b_n.8c81327a.svg";